/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Must_Be_Ad_ToastInputs */



/**
* | output |
* | --- |
* | "Selected Event Group must be of type: Audio Description" |
*
* @param {Render_Audio_Must_Be_Ad_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_must_be_ad_toast = /** @type {((inputs?: Render_Audio_Must_Be_Ad_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Must_Be_Ad_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe d'evenements selectionne doit etre de type : Description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die ausgewählte Ereignisgruppe muss vom Typ „Audiobeschreibung“ sein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo di eventi selezionato deve essere di tipo: Descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбранная группа событий должна быть типа: Аудиоописание")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo de eventos seleccionado debe ser del tipo: Descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所选活动组必须为：音频描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベント グループのタイプは、オーディオ説明である必要があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह का प्रकार ऑडियो विवरण होना चाहिए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de eventos selecionado deve ser do tipo: Descrição de áudio")
	return /** @type {LocalizedString} */ ("Selected Event Group must be of type: Audio Description")
});